import { defineComponent } from '@vue/composition-api';
import LoadingSpinner from '@/components/Loaders/LoadingSpinner.vue';
export default defineComponent({
    components: { LoadingSpinner },
});
